import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

const hoverElementStyles: NestedCSSProperties = {
  position: 'absolute',
  background: 'rgba(221, 221, 221, 0.9)',
  display: 'none',
};

const IMG_WIDTH = 110;
const IMG_HEIGHT = '100%';
const flatCard = style({
  position: 'relative',
  $debugName: 'flatCard',
  fontSize: '0.5rem',
  display: 'flex',
  flexDirection: 'row',
  $nest: {
    '&:hover': {
      $nest: {
        '.hoverElement': {
          ...hoverElementStyles,
          display: 'flex',
          height: 'inherit',
          width: 'inherit',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.5rem',
          fontVariant: 'all-petite-caps',
          zIndex: 1,
        },
      },
    },
    '&': {
      $nest: {
        '.hoverElement': {
          ...hoverElementStyles,
        },
      },
    },
    '.id': {
      fontSize: '0.7rem',
    },
    '.name': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      minHeight: 38,
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      // @ts-ignore // typestyle doesn't recognize this prop
      '-webkit-box-orient': 'vertical',
    },
    '.left-pane': {
      display: 'flex',
      padding: '1rem 0 1rem 1rem',
      flexGrow: 1,
      justifyContent: 'space-around',
      flexDirection: 'column',
      overflow: 'hidden',
      $nest: {
        '.star-ratings': {
          lineHeight: 0,
        },
      },
    },
    img: {
      padding: '0 1rem .2rem',
    },
    '&.collapsed': {
      $nest: {
        '.left-pane': {
          display: 'none',
        },
      },
    },
  },
});
const imgContainer = style({
  flexShrink: 0,
});
export { IMG_HEIGHT, IMG_WIDTH, flatCard, imgContainer };
